// Copyright (c) 2017 TrainHeroic LLC
// Actions for interacting with tables

export default {
    SET_EDIT_CELL: 'table-set-edit-cell',
    UI_CREATE_THUMB: 'table-ui-create-thumb',
    UI_EXERCISE_MODAL: 'table-ui-exercise-modal',
    UI_SAVING: 'table-ui-saving'
};



// WEBPACK FOOTER //
// ./src/state/reducer/uiTree/actions.js